import { faFacebookF, faTwitter, faBluesky, faInstagram, faGithub, faYoutube } from '@fortawesome/free-brands-svg-icons'

export const socialIcons = {
    facebook: faFacebookF,
    twitter: faTwitter,
    bluesky: faBluesky,
    instagram: faInstagram,
    youtube: faYoutube,
    github: faGithub,
}
